module.exports = __webpack_public_path__ + "img/太原旧机动车交易中心（有限公司）.e9d5b99c.jpg";